<template ref="indexAd">
  <section>
    <div class="m-ADBox">
      <!--<div class="AD-c" @mouseover="flownApart">
        <div class="lt">
          <div class="lineBox">
            <p class="line animate__animated animate__lightSpeedInLeft animate__delay-1s animate__slow"></p>
            <p class="line line2 animate__animated animate__lightSpeedInLeft animate__delay-1s animate__slow"></p>
          </div>
          <h2 class="h2 animate__bounce animate__animated animate__slow">提供深度定制互联网应用服务</h2>
          <h3 class="h3 animate__rotateInUpLeft animate__animated animate__delay-1s">涵盖企业的互联网品牌传播、数字营销、业务服务支撑等</h3>
          <ul class="btn-ul">
            <li class="btn-li animate__slideInUp animate__animated animate__slow" @click="jumpToHref($api.domainName + 'quotation.html')">企业网站开发</li>
            <li class="btn-li animate__slideInUp animate__animated animate__slower" @click="jumpToHref($api.domainName + 'quotation.html')">APP定制开发</li>
            <li class="btn-li animate__slideInUp animate__animated animate__delay-1s" @click="jumpToHref($api.domainName + 'quotation.html')">微信小程序开发</li>
          </ul>
        </div>
        <img class="ad-img" src="../../assets/bg2.png" alt="">
        <div class="m-luye" id="m-luye">
          <div v-for="(item,index) in bgImg" :key="index" class="luye-li" :style="bgPst(index)"></div>
        </div>
      </div>-->
      <Carousel
          v-if="swiperImg.length > 0"
          v-model="setting.current"
          :autoplay="setting.autoplay"
          :autoplay-speed="setting.autoplaySpeed"
          :dots="setting.dots"
          :radius-dot="setting.radiusDot"
          :trigger="setting.trigger"
          :arrow="setting.arrow">
        <CarouselItem v-for="(item,index) in swiperImg" :key="index">
          <div class="swiper-imgBox">
            <img class="swiper-img" :src="item.img" alt="">
          </div>
        </CarouselItem>
      </Carousel>
      <ul class="pt-ul" v-if="moduleData.length > 0">
        <li class="pt-li" v-for="(item,index) in moduleData" :key="index">
          <h4 class="h4 animate__swing  animate__animated animate__repeat-2">{{ item._title + item.unit }}</h4>
          <p class="p animate__fadeInBottomLeft animate__animated animate__slower">{{ item.subtitle }}</p>
        </li>
      </ul>
    </div>
    <div class="pt-ul-base"></div>
  </section>
</template>
<script>
export default {
  name       : 'index-ad',
  components : {},
  props      : {
    moduleData : {
      type    : Array,
      default : [],
    },
    swiperImg:{
      type:Array,
      default : []
    }
  },
  data(){
    return {
      bgImg          : [],
      loopFlownApart : true,
      setting        : {
        current       : 0,
        autoplay      : false,
        autoplaySpeed : 2000,
        dots          : 'none',
        radiusDot     : false,
        trigger       : 'click',
        arrow         : 'always',
      },
    };
  },
  computed   : {},
  watch : {
    moduleData : {
      handler(){
        this.$nextTick(() => {
          this.numScroll();
        })
      }
    }
  },
  beforeMount(){
  },
  created(){
  },
  mounted(){
    this.moduleData.map((item, index) => {
      this.numScroll(index, item.title.replace(/\D/g, ''));
    })
  },
  methods    : {
    numScroll(){
      this.moduleData.map((item, index) => {
        var num = item.title.replace(/\D/g, '');
        let fastest = 100; //间隔时间最快标准为64
        let timer = 5000 / num;
        var numScroll = setInterval(() => {
          if (timer < fastest) {
            this.moduleData[index]._title += parseInt(num / 50);
          } else {
            this.moduleData[index]._title += 1;
          }
          if (this.moduleData[index]._title >= num) {
            clearInterval(numScroll)
            this.moduleData[index]._title = num;
          }
        }, timer < fastest ? fastest : timer)
      })
    },
    jumpToHref(url){
      location.href = url;
    },
  },
};
</script>
<style scoped lang="scss">
@media screen and(min-width: 768px){
  .m-ADBox{
    .AD-c{
      margin: 0 2% 0 12%;
    }
  }
}
.m-ADBox{
  height: 31vw; /*根据比例算出37*/
  position: relative;
  .pt-ul{
    position: absolute;
    bottom: -0.6rem;
    left: 0;
    right: 0;
    z-index: 101;
    max-width: 1200Px;
    margin: auto;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 5Px;
    box-shadow: 0 3Px 4Px 1Px #ccc;
    .pt-li{
      flex: 1;
      height: 1.2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      padding: 0 0.1rem;
      .h4{
        font-size: 0.4rem;
        font-weight: normal;
      }
      .p{
        font-size: 0.17rem;
      }
    }
  }
}
.pt-ul-base{
  height: calc(0.6rem + 8px);
}
.swiper-imgBox{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 31vw;
  .swiper-img{
    width: 100%;
    height: 100%;
  }
}
</style>
